import React, { useState, FC } from 'react';
import { TextInput } from '@domain-group/fe-co-form-elements';
import { TickIcon, CloseIcon } from '@domain-group/fe-co-icon';
import { AccessLevelTable } from 'src/lib/docs-api';

interface EndpointPropsBrowserProps {
  fieldDefinition: AccessLevelTable;
}

const EndpointPropsBrowser: FC<EndpointPropsBrowserProps> = ({
  fieldDefinition,
}) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleSearchTermChanged = (
    eventInfo: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSearchTerm(eventInfo.currentTarget.value);
  };
  // todo:
  // - search box
  // - table
  return (
    <>
      {/* <p>Props browser: {fieldDefinition?.data?.length ?? -1}</p> */}
      <TextInput
        id="data-access-search-box"
        placeholder="Type to filter by property name"
        value={searchTerm}
        onChange={handleSearchTermChanged}
      />
      {searchTerm && <p>Filtering for &quot;{searchTerm}&quot;</p>}

      <table>
        <thead>
          <tr>
            <th>Property</th>
            <th>Basic</th>
            <th>Detailed</th>
            <th>Full</th>
          </tr>
        </thead>
        <tbody>
          {fieldDefinition?.data?.map((dataProperty) => {
            if (
              searchTerm &&
              dataProperty.Property.toLowerCase().indexOf(
                searchTerm.toLowerCase(),
              ) < 0
            ) {
              return <></>;
            }
            // console.log(dataProperty);
            return (
              <tr key={dataProperty.Property}>
                <td>{dataProperty.Property}</td>
                <td>
                  {dataProperty.Basic ? (
                    <TickIcon title="Yes" />
                  ) : (
                    <CloseIcon title="No" />
                  )}
                </td>
                <td>
                  {dataProperty.Detailed ? (
                    <TickIcon title="Yes" />
                  ) : (
                    <CloseIcon title="No" />
                  )}
                </td>
                <td>
                  {dataProperty.Full ? (
                    <TickIcon title="Yes" />
                  ) : (
                    <CloseIcon title="No" />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default EndpointPropsBrowser;
